import _ from 'lodash';

const getAllBogoSpecialsForCart = (items, medicalOrder, globalSpecialsSettings) => {
  const bogoSpecialsHash = _.reduce(
    _.flatMap(items, (item) => item?.specialData?.bogoSpecials || []),
    (hash, bogoSpecial) => {
      const { bogoRewards, discountToCart, discountBundle, itemsForAPrice, menuType, specialId } = bogoSpecial;

      if (
        (menuType === 'medical' && !medicalOrder) ||
        (menuType === 'recreational' && medicalOrder) ||
        ((bogoRewards || []).length < 1 &&
          !itemsForAPrice?.enabled &&
          !discountToCart?.enabled &&
          !discountBundle?.enabled)
      ) {
        return hash;
      }

      const existingSpecial = hash[bogoSpecial.specialId];

      if (!existingSpecial) {
        hash[specialId] = {
          ...bogoSpecial,
          discountPrecedence: bogoSpecial.discountPrecedence || globalSpecialsSettings.discountPrecedence,
        };
      } else {
        hash[specialId] = {
          ...existingSpecial,
          discountPrecedence: bogoSpecial.discountPrecedence || globalSpecialsSettings.discountPrecedence,
          bogoRewards: _.uniqBy([...(existingSpecial?.bogoRewards || []), ...(bogoRewards || [])], '_id'),
        };
      }

      return hash;
    },
    {}
  );

  return _.sortBy(_.values(bogoSpecialsHash), (special) => {
    if (special.isRecurring) {
      return special.recurringEndDate ? Number(special.recurringEndDate) : Infinity;
    }
    return special.endStamp ? Number(special.endStamp) : Infinity;
  });
};

export default getAllBogoSpecialsForCart;
